var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './login_input_field_styles.scss';
export var Variant;
(function (Variant) {
    Variant["formfield"] = "formfield";
    Variant["numberfield"] = "numberfield";
    Variant["password"] = "password";
})(Variant || (Variant = {}));
let LoginInput = class LoginInput extends LitElement {
    constructor() {
        super();
        this.label = 'type here';
        this.variant = 'formfield';
        this.text = '';
        this.valid = true;
        this.invalidText = '';
        this.id = this.generateRandomID();
    }
    createRenderRoot() {
        return this;
    }
    render() {
        return html `
            <div
                class="float-container"
                style="${this.width ? 'width: ' + this.width + ';' : ''} ${this.small ? 'height: 42px;' : ''}"
                valid="${this.valid}"
                disabled="${this.disabled === "true"}"
            >
                <label
                    for="${this.id}"
                    valid="${this.valid}"
                    disabled="${this.disabled === "true"}"
                    class="input_label ${this.hasFocus || this.text !== '' && this.text !== ' ' ? this.small ? 'focussed_small' : 'focussed' : ''}"
                    style="${this.labelColor && this.hasFocus || this.text !== '' && this.text !== ' ' ? 'background-color: ' + this.labelColor + ';' : ''} ${this.small ? 'height: 28px;' : ''}"
                >
                    ${this.label[0]?.toUpperCase() + this.label?.substr(1)}
                </label>
                <input
                    id="${this.id}"
                    type="${this.calculateType()}"
                    class="labeled"
                    style="${this.small ? 'height: 23px;' : ''}"
                    .value="${this.text}"
                    ?disabled="${this.disabled}"
                    @focus="${() => this.inputFocussed()}"
                    @blur="${() => this.focusLost()}"
                    @change="${(e) => this.inputChanged(e.target.value)}"
                    @keyup="${(e) => this.keyUp(e.target.value)}"
                    autocomplete="${this.stopAutoFill ? 'new-password' : ''}"
                    min="0"
                />
            </div>
            ${this.valid ? html `
                <div class="valid_box"></div>
            ` : html `
                <div class="invalid_message">${this.invalidText}</div>
            `}
        `;
    }
    calculateType() {
        if (this.variant === Variant.password) {
            return 'password';
        }
        else if (this.variant === Variant.numberfield) {
            return 'number';
        }
        else {
            return 'text';
        }
    }
    inputFocussed() {
        this.hasFocus = true;
    }
    focusLost() {
        this.hasFocus = null;
    }
    inputChanged(value) {
        this.text = value;
        super.dispatchEvent(new CustomEvent('change', {
            detail: {
                value: value.trim(),
            }
        }));
    }
    keyUp(value) {
        super.dispatchEvent(new CustomEvent('keypressed', {
            detail: {
                value: value.trim() || '',
            }
        }));
    }
    generateRandomID() {
        return Math.random().toString(36).substr(2, 9);
    }
};
__decorate([
    property({ type: String })
], LoginInput.prototype, "label", void 0);
__decorate([
    property({ type: String })
], LoginInput.prototype, "variant", void 0);
__decorate([
    property({ type: String })
], LoginInput.prototype, "text", void 0);
__decorate([
    property({ type: Boolean })
], LoginInput.prototype, "valid", void 0);
__decorate([
    property({ type: String })
], LoginInput.prototype, "invalidText", void 0);
__decorate([
    property({ type: Boolean })
], LoginInput.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean })
], LoginInput.prototype, "hasFocus", void 0);
__decorate([
    property({ type: String })
], LoginInput.prototype, "width", void 0);
__decorate([
    property({ type: Boolean })
], LoginInput.prototype, "small", void 0);
__decorate([
    property({ type: Boolean })
], LoginInput.prototype, "stopAutoFill", void 0);
__decorate([
    property({ type: String })
], LoginInput.prototype, "labelColor", void 0);
LoginInput = __decorate([
    customElement('dn-login-input-field')
], LoginInput);
export default LoginInput;
